<template>
  <div class="footer">
    <v-footer padless>
      <v-card class="flex" flat tile>
        <v-card-title class="secondary">
          <img v-show="logoRodape"
              class="ml-3"
              :src="`data:image/png;base64,${logoRodape}`"
              alt="Brasão Prefeitura"
              width="150"/>

          <div class="flex-grow-1"></div>

          <v-btn v-show="redesSociais.length > 0"
              v-for="item in redesSociais"
              :key="item.icon"
              class="mx-4 hidden-xs-only"
              dark
              icon
              :href="item.url"
              target="_blank">
            <v-icon size="24px">{{ item.icon }}</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-actions v-show="siglaEmpresa" class="justify-center grey lighten-4">
          {{ new Date().getFullYear() }}.
          <span class="font-weight-light">
            {{siglaEmpresa}} - {{nomeEmpresa}}
          </span>
        </v-card-actions>
      </v-card>
    </v-footer>
  </div>
</template>

<script>
import EventService from "../services/EventService";

export default {
  props: {
    logoRodape: { type: String, required: true },
    siglaEmpresa: { type: String, required: true },
    nomeEmpresa: { type: String, required: true },
  },
  name: "Footer",
  data() {
    return {
      facebookLink: "",
      twitterLink: "",
      youtubeLink: "",
      instagramLink: "",
      redesSociais: [],
    };
  },
  created() {
    EventService.getConteudo().then(response => {
      this.facebookLink = response.data.facebook;
      this.twitterLink = response.data.twitter;
      this.youtubeLink = response.data.youtube;
      this.instagramLink = response.data.instagram;
      this.flickrLink = response.data.flickr;

      if (this.facebookLink) {
        this.redesSociais.push({
          icon: "fab fa-facebook",
          url: this.facebookLink,
        });
      }

      if (this.twitterLink) {
        this.redesSociais.push({
          icon: "fab fa-twitter",
          url: this.twitterLink,
        });
      }

      if (this.youtubeLink) {
        this.redesSociais.push({
          icon: "fab fa-youtube",
          url: this.youtubeLink,
        });
      }

      if (this.instagramLink) {
        this.redesSociais.push({
          icon: "fab fa-instagram",
          url: this.instagramLink,
        });
      }

      if (this.flickrLink) {
        this.redesSociais.push({
          icon: "fab fa-flickr",
          url: this.flickrLink,
        });
      }
    });
  },
};
</script>
